import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

// Starter Reducers
import AuthReducer from './redux/Auth/auth.reducer'
import UIReducer from './redux/UI/ui.reducer'
import UsersReducer from './redux/Users/users.reducer'
import AccountReducer from './redux/Account/account.reducer'
import BillingReducer from './redux/Billing/billing.reducer'
import NetworkReducer from './redux/Network/network.reducer'
import UserPreference from './modules/UserPreferences/redux/userpreferences.reducer'
import PlatformEvents from './modules/PlatformEvents/redux/platformevent.reducer';

// App Reducers
import NetworkProducts from './modules/NetworkProducts/redux/networkproduct.reducer'
import NetworkOrders from './modules/NetworkOrders/redux/networkorder.reducer';
import Media from './modules/Media/redux/media.reducer';
import MediaTags from './modules/Media/redux/mediatag.reducer';

// CAPTURE COLLAB
import Libraries from './capturecollab/modules/Library/redux/library.reducer';
import Albums from './capturecollab/modules/Album/redux/album.reducer';
import People from './capturecollab/modules/People/redux/people.reducer';
import Location from './capturecollab/modules/Location/redux/locations.reducer';
import GenericTags from './capturecollab/modules/GenericTags/redux/generictags.reducer';
import Assets from './capturecollab/modules/Assets/redux/assets.reducer';
import UserEngagements from './capturecollab/modules/UserEngagement/redux/userengagement.reducer'
import Comments from './capturecollab/modules/Comments/redux/comments.reducer';
import Permissions from './capturecollab/modules/Permission/redux/permissions.reducer';
import Views from './capturecollab/modules/Views/redux/views.reducer';


export const globalReducer = (history) => combineReducers({
  router: connectRouter(history),
  auth: AuthReducer,
  ui: UIReducer,
  users: UsersReducer,
  account: AccountReducer,
  billing: BillingReducer,
  network: NetworkReducer,
  userpreference: UserPreference,
  networkproducts: NetworkProducts,
  networkorders: NetworkOrders,
  media: Media,
  mediatags: MediaTags,
  platformevents: PlatformEvents,
  libraries: Libraries,
  albums: Albums,
  people: People,
  locations: Location,
  generictags: GenericTags,
  assets: Assets,
  userengagements: UserEngagements,
  comments: Comments,
  permissions: Permissions,
  views: Views
})